import { Event } from "mapbox-gl";
import { Map } from "mapbox-gl";
import { useEffect, useRef } from "react";
function useMapboxEvent(
    map: Map | null,
    event: string,
    handler: (e: Event) => void,
) {
    const handlerRef = useRef(handler);

    handlerRef.current = handler;

    useEffect(() => {
        if (!map) return;

        const stableHandler = (e: Event) => handlerRef.current(e);

        map.on(event, stableHandler);
        return () => {
            map.off(event, stableHandler);
        };
    }, [map, event]);
}

export default useMapboxEvent;
